module.exports = __webpack_public_path__ + "static/img/page26.e8def4c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/page26.jpg
// module id = DmJP
// module chunks = 0